import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "List" }
const _hoisted_2 = { class: "List__Inner section__inner" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "List__Background color--4" }, null, -1)
const _hoisted_4 = { class: "List__Subinner section__subinner" }
const _hoisted_5 = { class: "List__Subinner__Left" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "List__Subinner__Right" }
const _hoisted_8 = {
  key: 0,
  class: "section-text-large"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 88 56",
  class: "color--1"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-list-item" })
], -1)
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.slide?.title)
            ? (_openBlock(), _createElementBlock("h2", {
                key: 0,
                class: "section-title-small color--1",
                innerHTML: _ctx.breaks(_ctx.slide.title)
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.slide?.items)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slide.items, (item, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `slide-list-${_ctx.index}-${i}`
                  }, [
                    _hoisted_9,
                    _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_10)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}